import * as Constants from '../../constants';
import { ApiActions } from '../../constants/ApiActions';
import { getFromMap } from '../../lib/CoreUtils';
import { Map } from '../../lib/ImmutableUtils';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map<$TSFixMe>({});
export type EntitiesPlaylistTracksState = typeof INITIAL_STATE;

// PLAYLIST TRACK REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.ADD_FEEDBACK_SUCCESS]: handleFeedback,
  [ApiActions.DELETE_FEEDBACK_SUCCESS]: handleFeedback,
  [ApiActions.FLAG_MESSAGE_SUCCESS]: flagMessageSuccess,
  [Constants.Playback.ActionTypes.INSERT_TRACK_INTO_PLAYLIST]: insertTrackIntoPlaylist,
  [ApiActions.GET_FRAGMENT_SUCCESS]: playlistChange,
  [ApiActions.GET_REPLAY_TRACK_SUCCESS]: playlistChange,
  [Constants.Ads.Audio.Actions.REMOVE_AUDIO_AD_FROM_QUEUE]: audioAdQueueRemove,
  [Constants.Ads.Audio.Actions.ADD_AUDIO_ADS_TO_QUEUE]: audioAdQueueAdd,
  [ApiActions.FETCH_NARRATIVE_SUCCESS]: fetchNarrativeSuccess,
});

// CASE FUNCTIONS

function handleFeedback(
  state: EntitiesPlaylistTracksState,
  action: $TSFixMe,
): EntitiesPlaylistTracksState {
  return state.mergeDeep(action.updateEntitiesWith);
}

function flagMessageSuccess(
  state: EntitiesPlaylistTracksState,
  action: $TSFixMe,
): EntitiesPlaylistTracksState {
  // @ts-expect-error
  return state.map(playlistTrack => {
    if (playlistTrack.get('musicId') === action.updateEntitiesWith.trackId) {
      return playlistTrack.set('isFlaggedMessage', true);
    }
    return playlistTrack;
  });
}

function insertTrackIntoPlaylist(
  state: EntitiesPlaylistTracksState,
  action: $TSFixMe,
): EntitiesPlaylistTracksState {
  // @ts-expect-error
  return state.map((playlistTrack, key) => {
    if (key === action.data.trackToken) {
      return playlistTrack.set(Constants.Playback.IS_REPLAYED_TRACK, true);
    }
    return playlistTrack;
  });
}

function playlistChange(
  state: EntitiesPlaylistTracksState,
  action: $TSFixMe,
): EntitiesPlaylistTracksState {
  const playlistTrackEntities = action.response.entities.playlistTracks;

  Object.keys(playlistTrackEntities).forEach(entityId => {
    const track = playlistTrackEntities[entityId];

    if (AUDIO_URL_DEV_PROXY_DECRYPTION_KEY) {
      // For proxied encrypted tracks we need to overwrite the API response
      track.audioEncoding = Constants.AudioPlayer.AudioEncodingFormats.MP4;
    } else {
      // For all other tracks just standardize the encoding name
      track.audioEncoding =
        // @ts-expect-error
        Constants.AudioPlayer.AudioFormatToCommonTypes[track.audioEncoding] || track.audioEncoding;
    }
  });
  return state.mergeDeep(playlistTrackEntities);
}

function audioAdQueueRemove(
  state: EntitiesPlaylistTracksState,
  { data: { ad: adTrack } }: $TSFixMe,
): EntitiesPlaylistTracksState {
  if (!adTrack) {
    return state;
  }
  const token = getFromMap(adTrack, 'trackToken');
  // @ts-expect-error
  return state.delete(token);
}

function audioAdQueueAdd(
  state: EntitiesPlaylistTracksState,
  { data: { ads } }: $TSFixMe,
): EntitiesPlaylistTracksState {
  if (ads) {
    let token;
    const toMerge = {};
    // @ts-expect-error
    ads.forEach(ad => {
      token = getFromMap(ad, 'trackToken');
      // @ts-expect-error
      toMerge[token] = ad;
    });
    return state.mergeDeep(toMerge);
  }
  return state;
}

function fetchNarrativeSuccess(
  state: EntitiesPlaylistTracksState,
  action: $TSFixMe,
): EntitiesPlaylistTracksState {
  if (!action.isAPSEnabled) {
    return state.mergeDeep({
      [action.updateEntitiesWith.trackToken]: {
        narrative: {
          fromTrack: true,
          ...action.response,
        },
      },
    });
  }
  return state;
}
